var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export function Tasks(_a) {
    var color = _a.color, size = _a.size;
    return (_jsx("svg", __assign({ width: size, height: size, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M5.00016 18.3334C4.54183 18.3334 4.14947 18.1702 3.82308 17.8438C3.49669 17.5174 3.3335 17.125 3.3335 16.6667V3.33335C3.3335 2.87502 3.49669 2.48266 3.82308 2.15627C4.14947 1.82988 4.54183 1.66669 5.00016 1.66669H11.6668L16.6668 6.66669V10H15.0002V7.50002H10.8335V3.33335H5.00016V16.6667H10.0002V18.3334H5.00016ZM15.2502 12.1042L16.146 13L12.9168 16.2084V17.0834H13.7918L17.021 13.875L17.896 14.75L14.3127 18.3334H11.6668V15.6875L15.2502 12.1042ZM17.896 14.75L15.2502 12.1042L16.4585 10.8959C16.6113 10.7431 16.8057 10.6667 17.0418 10.6667C17.2779 10.6667 17.4724 10.7431 17.6252 10.8959L19.1043 12.375C19.2571 12.5278 19.3335 12.7222 19.3335 12.9584C19.3335 13.1945 19.2571 13.3889 19.1043 13.5417L17.896 14.75Z", fill: color }) })));
}
